export default {
  ARTICLES(state, data) {
    state.articles        = data;
    state.articlesLoading = false;
  },

  ARTICLES_PAGE(state, data) {
    state.articlesPage = data;
  },

  ARTICLES_PAGE_LAST(state, data) {
    state.articlesPageLast = data;
  },

  ARTICLES_SEARCH(state, data) {
    state.articlesSearch = data;
  },

  ARTICLES_TOP(state, data) {
    state.articlesTop        = data;
    state.articlesTopLoading = false;
  },

  CATEGORIES(state, data) {
    state.categories        = data;
    state.categoriesLoading = false;
  },

  CATEGORIES_CURRENT(state, data) {
    state.categoriesCurrent = data;
  },

  SPECIALIST_ARTICLES(state, response) {
    state.specialistArticles = response.data.articles;
  }
}
